import { publicRequest } from "../../requestMethod";


export const FETCH_REVIEW_REQUEST = 'FETCH_REVIEW_REQUEST';
export const FETCH_REVIEW_SUCCESS = 'FETCH_REVIEW_SUCCESS';
export const FETCH_REVIEW_FAILURE = 'FETCH_REVIEW_FAILURE';




export function fetchReview(id) {
  return async(dispatch) => {
   const {data}= await publicRequest.get(`/api/review/${id}`)
   if (data) {
    
        dispatch({type: FETCH_REVIEW_SUCCESS, payload: data});
    }else{
        dispatch({type: FETCH_REVIEW_FAILURE})
    }
   }
  }

export function fetchAllReviews() {
  return async(dispatch) => {
   const {data}= await publicRequest.get(`/api/review`)
   if (data) {
    
        dispatch({type: FETCH_REVIEW_SUCCESS, payload: data});
    }else{
        dispatch({type: FETCH_REVIEW_FAILURE})
    }
   }
  }
export function fetchMyReviews(wallet) {
  console.log(wallet);
  return async(dispatch) => {
   const {data}= await publicRequest.get(`/api/review/myreview/${wallet}`)
   if (data) {
    
        dispatch({type: FETCH_REVIEW_SUCCESS, payload: data});
    }else{
        dispatch({type: FETCH_REVIEW_FAILURE})
    }
   }
  }



export function addReview(reviewdata, addToast) {

  return async(dispatch) => {
   
   const {data}= await publicRequest.post(`/api/review/add/${reviewdata.id}`, reviewdata)
  if (data.message&& data.message==='already reviewed') {
    addToast("You already reviewed this NFT project!", { appearance: "error", autoDismiss: true });
    return;
  }
  
   if (data) {
    if (addToast) {
        addToast("Review added successfully", { appearance: "success", autoDismiss: true });
      }
      dispatch(fetchReview(reviewdata.id))
    return data
     
        
    }else{
        dispatch({type: FETCH_REVIEW_FAILURE})
        addToast("Problem with adding review", { appearance: "success", autoDismiss: true });
    }
   }
  }

  export function deleteReview(id, addToast) {
    return async(dispatch) => {
     const {data}= await publicRequest.delete(`/api/review/delete/${id}`)
    
     if (data) {
      if (addToast) {
        addToast("Review deleted successfully", { appearance: "error", autoDismiss: true });
      }
         await dispatch(fetchAllReviews());
        
          
      }else{
        if (addToast) {
          addToast("Something went wrong!", { appearance: "error", autoDismiss: true });
        }
      }
     }
    }
  export function deleteMyReview(id, addToast) {
    return async(dispatch) => {
     const {data}= await publicRequest.delete(`/api/review/delete/${id}`)
    
     if (data) {
      if (addToast) {
        addToast("Review deleted successfully", { appearance: "error", autoDismiss: true });
      }
         await dispatch(fetchMyReviews());
        
          
      }else{
        if (addToast) {
          addToast("Something went wrong!", { appearance: "error", autoDismiss: true });
        }
      }
     }
    }
  

